import { Container, createStyles, makeStyles } from "@material-ui/core"
import React from "react"


type Props = {

}

export const FlutterWaitlist = (props: Props) => {
    const classes = useStyles({});
    return <div className={classes.section}>
        <Container maxWidth='sm' id='register' style={{
            textAlign: 'center',
            padding: 0,
        }}>
            <iframe
                src="https://docs.google.com/forms/d/e/1FAIpQLScRamxbIl0m0lnKzFBqLNYK6fmrblGwqY7KJCTh_BGyWbS8Bw/viewform?embedded=true"
                width="100%"
                height="1500" frameBorder="0"
                marginHeight={0} marginWidth={0}>Loading…</iframe>
        </Container>
    </div>
}

const useStyles = makeStyles(theme => createStyles({
    section: {
        padding: theme.spacing(6, 0),
        '& iframe': {
            textAlign: 'center',
        },
    },
}))